import TwoColumnLayout from 'layouts/two-column-layout/two-column-layout'

import AddressSelection from './address-selection/address-selection.component'
import AddressDetails from './address-details/address-details.component'
import AddressProvider from './address.provider'

const AddressPage = () => {
  return (
    <AddressProvider>
      <TwoColumnLayout>
        <AddressSelection />
        <AddressDetails />
      </TwoColumnLayout>
    </AddressProvider>
  )
}

export default AddressPage
